export default __webpack_public_path__ + "static/media/tracking.fbc8ab63.svg";